module.exports = __webpack_public_path__ + "static/img/v_9.af37f3a3.png";